import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref } from 'vue'
import MainLayout from './components/MainLayout.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'Dashboard',
  setup(__props, { expose: __expose }) {

const mainLayoutRef = ref()

// Expose refresh function for parent components
__expose({
  refreshStats: () => mainLayoutRef.value?.refreshStats()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(MainLayout, {
    ref_key: "mainLayoutRef",
    ref: mainLayoutRef
  }, {
    default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
      _createElementVNode("div", { class: "dashboard-content" }, [
        _createElementVNode("div", { class: "welcome-section" }, [
          _createElementVNode("h1", null, [
            _createTextVNode("Welcome to "),
            _createElementVNode("span", { class: "highlight" }, "Prec8")
          ]),
          _createElementVNode("p", { class: "subtitle" }, "Recognize and celebrate your team's achievements")
        ]),
        _createElementVNode("div", { class: "decoration" }, [
          _createElementVNode("div", { class: "floating-card card-1" }, [
            _createElementVNode("span", { class: "emoji" }, "🌟"),
            _createElementVNode("p", null, "Keep up the great work!")
          ]),
          _createElementVNode("div", { class: "floating-card card-2" }, [
            _createElementVNode("span", { class: "emoji" }, "🚀"),
            _createElementVNode("p", null, "Ready to recognize others?")
          ])
        ])
      ], -1)
    ]))]),
    _: 1
  }, 512))
}
}

})